import axios from "axios";
import config from "@/config/env.config.json";
import logger from "@/utils/logger";

const envConfig = config[process.env.NODE_ENV];
const consumerBaseUrl = envConfig.consumerApiBaseUrl;
const userProfilesApi = {};

userProfilesApi.getById = async (id) => {
  try {
    const url = `${consumerBaseUrl}/user_profiles/${id}`;
    console.log("API REQUEST", "GET", url);
    const response = await axios.get(url);
    console.log("API RESPONSE", "GET", url, response.status, response.data);
    logger.info(response.data);
    return response.data;
  } catch (error) {
    console.error("API ERROR", "GET", "getById", error);
    logger.error(error);
    throw error;
  }
};

userProfilesApi.getUsersDevices = async (userProfileId) => {
  try {
    const url = `${consumerBaseUrl}/user_profiles/${userProfileId}/devices`;
    console.log("API REQUEST", "GET", url);
    const response = await axios.get(url);
    console.log("API RESPONSE", "GET", url, response.status, response.data);
    logger.info(response.data);
    return response.data;
  } catch (error) {
    console.error("API ERROR", "GET", "getUsersDevices", error);
    logger.error(error);
    throw error;
  }
};

export default userProfilesApi;
